var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtpPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "634 483 15.711 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #868686;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lock",
    transform: "translate(846.4 534)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    className: "cls-1",
    d: "M13.067,6.4V5.111a5.078,5.078,0,1,0-10.156,0V6.4H2.667A2.66,2.66,0,0,0,0,9.067v8.267A2.66,2.66,0,0,0,2.667,20H13.044a2.66,2.66,0,0,0,2.667-2.667V9.067A2.641,2.641,0,0,0,13.067,6.4ZM8.6,14.867a.726.726,0,0,1-.733.733.712.712,0,0,1-.733-.733V13.422a.733.733,0,0,1,1.467,0Zm3-8.467H4.356V5.111a3.622,3.622,0,1,1,7.244,0Z",
    transform: "translate(-212.4 -51)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtpPassword);
export default __webpack_public_path__ + "static/media/otp_password.44e1c2a24e84cb50fc540c980013d2f0.svg";
export { ForwardRef as ReactComponent };